import axios from "./axios";

//行程统计数据
export const queryWebDigitalRec = (data) => {
	return axios({
		act: "v1/queryWebDigitalRec",
		method: "post",
		data: data
	});
}

//行程详情
export const queryWebDigitalRecDetail = (data) => {
	return axios({
		act: "v1/queryWebDigitalRecDetail",
		method: "post",
		data: data
	});
}


//单车仪表盘数据
export const QuerySwitchStatus = (data) => {
	return axios({
		act: "v1/QuerySwitchStatus",
		method: "post",
		data,
	});
};
export const topaffiche = (data) => {
	return axios({
		act: "v3/basic/topaffiche",
		method: "get",
		params: data
	});
};
export const queryVideoDeviceNo = (data) => {
	return axios({
		act: "v1/queryVideoDeviceNo",
		method: "post",
		data,
	});
};
//查询记录仪终端编号
export const queryVideoDeviceNoRecorder = (data) => {
	return axios({
		act: "v1/queryVideoDeviceNoRecorder",
		method: "post",
		data,
	});
};

//查询车辆电池日分析
export const queryVehicleBatteryDaily = (data) => {
	return axios({
		act: "v3/vehicle/battery_analysis",
		method: "get",
		params: data
	});
};
//查询车辆32960数据
export const queryVehicle32960Data = (data, responseType) => {

	return axios({
		act: "v3/vehicle/vehicle_32960",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};



//查询车辆速度里程分析曲线
export const queryVehicleSpeedMileageAnalysisCurve = (data) => {
	return axios({
		act: "v3/vehicle/vehicle_speed_mileage_analysis_curve",
		method: "get",
		params: data
	});
};


//查询车辆基本信息
export const queryVehicleBaseInfo = (data) => {
	return axios({
		act: "v1/queryVehicleBaseInfo",
		method: "post",
		data
	});
};
//查询车辆新能源信息
export const queryVehicleNewEngineBaseInfo = (data) => {
	return axios({
		act: "v1/queryVehicleNewEngineBaseInfo",
		method: "post",
		data
	});
};
export const queryRealTimeVehicleInfo = (data) => {
	return axios({
		act: "v1/queryRealTimeVehicleInfo",
		method: "post",
		data
	});
};

//查询菜单信息
export const queryMenuInfo = (data) => {
	return axios({
		act: "v1/queryMenuInfo",
		method: "post",
		data
	});
};

//查询长期未联网记录
export const queryLongStayRec = (data, responseType) => {
	return axios({
		act: "v1/queryLongStayRec",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询电池数据
export const QueryAbroadCANBattery = (data, responseType) => {
	return axios({
		act: "v1/QueryAbroadCANBattery",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询整车数据
export const QueryAbroadCANVehicle = (data, responseType) => {
	return axios({
		act: "v1/QueryAbroadCANVehicle",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询电机数据
export const QueryAbroadCANMotor = (data, responseType) => {
	return axios({
		act: "v1/QueryAbroadCANMotor",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

export const queryVideoDeviceNoByTime = (data, responseType) => {
	return axios({
		act: "v1/queryVideoDeviceNoByTime",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询酒测数据
export const queryVehicleAlcoholData = (data, responseType) => {

	return axios({
		act: "v3/vehicle/alcohol_data",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};

//查询酒测数据详情
export const queryAlcoholTestDataDetail = (data, responseType) => {
	return axios({
		act: "v1/queryAlcoholTestData",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询车辆运行分析报告数据
export const queryOperationAnalysisReport = (data, responseType) => {
	return axios({
		act: "v1/queryOperationAnalysisReport",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};


//查询智驱的线路列表
export const queryAutoRouteList = (data, responseType) => {

	return axios({
		act: "v3/vehicle/auto_route_info",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};
export const queryAutoRouteAreaList = (data, responseType) => {

	return axios({
		act: "v3/vehicle/auto_route_area_list",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};

//查询智驱的线路轨迹区域列表
export const queryAutoRouteAreaListByVehicle = (data, responseType) => {

	return axios({
		act: "v3/vehicle/auto_route_area_list_by_vehicle",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};


//保存智驱的线路轨迹区域列表
export const saveAutoRouteInfo = (data, responseType) => {

	return axios({
		act: "v3/vehicle/save_auto_route_info",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};


export const deleteAutoRouteInfo = (routeID) => {
	return axios({
		act: "v3/vehicle/auto_route_info/" + routeID,
		method: "delete",

	})
}

export const GetLastFileUpLoadInfo808ByCompanyID = (data, responseType) => {

	return axios({
		act: "v3/vehicle/last_file_up_load_info_808",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};

export const GetAutoRouteAreaListByVFileID = (data, responseType) => {

	return axios({
		act: "v3/vehicle/auto_route_area_list_by_vfileid",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};


//查询终端历史的升级记录
export const GetVehicleUpGradeRecFTPByVehicleID = (data, responseType) => {

	return axios({
		act: "v3/vehicle/vehicle_upgrade_rec_ftp",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};


//查询终端历史的升级记录
export const GetVehicleLoginInfoByVehicleID = (data, responseType) => {

	return axios({
		act: "v3/vehicle/vehicle_login_info",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};

export const QueryVehicleVersionInfoFTP = (data, responseType) => {

	return axios({
		act: "v3/vehicle/vehicle_version_info_ftp",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

export const SetVehicleAutoRouteFileFTP = (data, responseType) => {

	return axios({
		act: "v3/vehicle/set_vehicle_auto_route_file_down_load",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

export const GetEngineModelDefineList = (data, responseType) => {

	return axios({
		act: "v3/vehicle/engine_model_define",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};

//查询智驱的发动机参数
export const querySmartEngineParam = (data, responseType) => {

	return axios({
		act: "v3/vehicle/smart_engine_param",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};


//查询智驱的发动机参数定义
export const GetDistinctEngineModelDefineList = (data, responseType) => {

	return axios({
		act: "v3/vehicle/distinct_engine_model_define",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};


//查询智驱的发动机参数定义
export const querySmartEngineParamByDistinctEngineModelID = (data, responseType) => {

	return axios({
		act: "v3/vehicle/smart_engine_param_by_distinct_engine_model_id",
		method: "get",
		params: data,
		responseType: responseType || 'json'
	});
};
export const SaveSmartEngineParam = (data, responseType) => {

	return axios({
		act: "v3/vehicle/save_smart_engine_param",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};

//查询维保提醒记录
export const maintananceReminder = (data, responseType) => {

	return axios({
		act: "v1/maintananceReminder",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};
//批量设置已读
export const maintanancePatchRead = (data, responseType) => {

	return axios({
		act: "v1/maintanancePatchRead",
		method: "post",
		data,
		responseType: responseType || 'json'
	});
};